import React from 'react'
import { useTranslation } from 'react-i18next'

import deskbookCoverImage from 'assets/images/deskbook-cover-image.webp'

import { StyledGoodNews as S } from './GoodNews.styles'

export const GoodNews: React.FC = () => {
  const { t } = useTranslation()

  return (
    <S.Wrapper>
      <S.Title>{t('onboarding.landingWellness.goodNews.title')}</S.Title>

      <S.Card>
        <S.Cover src={deskbookCoverImage} alt="The Islamic Wellness Deskbook" />
        <S.Description>
          {t('onboarding.landingWellness.goodNews.description')}
        </S.Description>
      </S.Card>
    </S.Wrapper>
  )
}
